module.exports = __webpack_public_path__ + "img/widescreen_off.8c258f82.png";